import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetAcademicOverviewData } from 'domain/usecases';
import { IAcademicOverviewFilters } from 'presentation/app/modules/Reports/models/academic-overview-filters';

interface IAcademicOverviewState {
  filters: IAcademicOverviewFilters;
  data: GetAcademicOverviewData.Result;
}

interface IPayloadAcademicOverviewFilters
  extends PayloadAction<IAcademicOverviewFilters> {}

interface IPayloadData extends PayloadAction<GetAcademicOverviewData.Result> {}

const initialState: IAcademicOverviewState = {
  filters: null,
  data: null,
};

export const AcademicOverviewSlice = createSlice({
  name: 'academic-overview',
  initialState,
  reducers: {
    loadData: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    loadFilters: (state, action: IPayloadAcademicOverviewFilters) => {
      state.filters = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
  },
});

export const { loadData, loadFilters, clearFilters } =
  AcademicOverviewSlice.actions;

export default AcademicOverviewSlice.reducer;
